export default "__VITE_ASSET__BfLq1$1v__"